var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Converts an array to an object whose
 * keys are generated via the predicate function
 *
 * @template T
 * @param {T[]} data
 * @param {((item: T) => string | null)} predicate Receives the data at each array index and returns a string that is used as the object key
 * @return {*}  {Record<string, T>}
 *
 * @example
 * categoriseArrayByObjectPropertyName([ { 'name': 'andy', 'age': 27 }, { 'name': 'bob', 'age': 30 } ], 'name');
 * // return { 'andy': { 'name': 'andy', 'age': 27 }, 'bob': { 'name': 'bob', 'age': 30 } }
 *
 */
export var categoriseArrayByObjectPropertyName = function (data, predicate) { return data.reduce(function (result, item) {
    var _a;
    return (__assign(__assign({}, result), (_a = {}, _a[predicate(item)] = item, _a)));
}, {}); };
//# sourceMappingURL=categoriseArrayByObjectPropertyName.js.map